import { render, staticRenderFns } from "./ContentPageForm.vue?vue&type=template&id=5f3c9cfc&"
import script from "./ContentPageForm.ts?vue&type=script&lang=js&"
export * from "./ContentPageForm.ts?vue&type=script&lang=js&"
import style0 from "./ContentPageForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports